const toggleClass = e => {
  const target = e.target.dataset.target
  const element = document.querySelector(target)
  if (!element) return

  element.classList.toggle('active')
}

export default toggleClass
